import { Box, Button, Flex, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { useState } from 'react';
import { BiCheck } from 'react-icons/bi';
import { Link } from 'react-router-dom';

import { updateNotification } from '@/api';
import { Notification } from '@/types';

function NotificationItem({
  notification,
  onClose,
}: {
  notification: Notification;
  onClose: () => void;
}) {
  const parsedContent = JSON.parse(notification.content);
  const [displayEnabled, setDisplayEnabled] = useState(notification.enabled);
  const [loading, setLoading] = useState(false);

  const titleMap = {
    'new-follow-up': {
      title: 'Nova atualização da pesquisa',
      message: (
        <>
          Há uma nova atualização na pesquisa{' '}
          <Link
            to={`/pesquisas?numberComlicitacao=${parsedContent.numberComlicitacaoSearch}`}
            onClick={onClose}
          >
            <Text textDecoration="underline">{parsedContent.numberComlicitacaoSearch}</Text>
          </Link>
        </>
      ),
    },
    'expired-certificate': {
      title: 'Certificado expirado',
      message: (
        <Box
          transition="all 0.3s"
          borderRadius="1rem"
          py="1rem"
          px="1rem"
          _hover={{ bgColor: 'primary.100' }}
        >
          <Link to={`/certidoes-rts`} onClick={onClose}>
            <Text>{`Renovar a certidão ${parsedContent.fileNumber}.`}</Text>
          </Link>
        </Box>
      ),
    },
    'opportunity-notification': {
      title: 'Oportunidade',
      message: (
        <Box
          transition="all 0.3s"
          borderRadius="1rem"
          py="1rem"
          px="1rem"
          _hover={{ bgColor: 'primary.100' }}
        >
          <Link to={`/oportunidades/${parsedContent?.id}`} onClick={onClose}>
            <Text>{parsedContent?.text}</Text>
          </Link>
        </Box>
      ),
    },
  };

  const handleChangeEnabled = async () => {
    const targetEnabled = !displayEnabled;

    try {
      setLoading(true);
      setDisplayEnabled(targetEnabled);
      await updateNotification({ id: notification.id, body: { enabled: targetEnabled } });
    } catch (err) {
      setDisplayEnabled(!targetEnabled);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box borderTop="1px solid rgb(233, 234, 242)" px="1rem">
      <Flex mt="1rem">
        <Text fontSize="1.125rem" fontWeight={500} mb="1.25rem" w="calc(100% - 3rem)">
          {titleMap[notification.title]?.title || 'Notificação desconhecida'}
        </Text>
        <Text fontSize="1.125rem" letterSpacing="0.045rem" color="#5f6979">
          {dayjs(notification.createdAt).format('DD/MM')}
        </Text>
      </Flex>
      <Text fontSize="1rem" fontWeight={500} mb="1.25rem">
        {titleMap[notification.title]?.message || ''}
      </Text>
      <Flex mb="1rem">
        {displayEnabled ? (
          <Button colorScheme="primary" onClick={handleChangeEnabled} isLoading={loading}>
            Marcar como lida
          </Button>
        ) : (
          <Flex alignItems="center" gap="4">
            <Button colorScheme="primary" disabled isLoading={loading}>
              Lida
              <BiCheck />
            </Button>
            {!notification.enabled && <Text>Por: {notification?.viewerUser?.name}</Text>}
          </Flex>
        )}
      </Flex>
    </Box>
  );
}

export default NotificationItem;
